/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MitteilungenSendenRequest2 { 
    fb_benutzer_funktionsbereich_ids?: Array<string>;
    fb_freigeber_funktionsbereich_ids?: Array<string>;
    rolle_benutzer_rollen_ids?: Array<string>;
    senden_an_alle_fb_freigeber?: boolean;
    senden_an_dienstplan?: boolean;
    senden_an_fb_benutzer?: boolean;
    senden_an_fb_freigeber?: boolean;
    senden_an_rolle_benutzer?: boolean;
    text: string;
    veranstaltung_id: string;
}

